import ManageDealUpdateNewPayload from "@/models/managedealnewupdate-payload";

export default class ManageDealNewPayloadFactory {
  static createFromJson(json) {
    return new ManageDealUpdateNewPayload(json);
  }

  static createFromJsonArray(jsonArray) {
    if (Array.isArray(jsonArray)) {
      return jsonArray.map((item) =>
        ManageDealNewPayloadFactory.createFromJson(item)
      );
    } else if (typeof jsonArray === "object" && jsonArray !== null) {
      return ManageDealNewPayloadFactory.createFromJson(jsonArray);
    } else {
      console.error("Input is not an array or an object");
      return [];
    }
  }
}
